import React, { PureComponent } from 'react'
import { Pane, TextInput, Checkbox, Link, toaster, Text, Dialog, Alert, Spinner } from 'evergreen-ui'
import { Button} from "antd";
import { Typography } from 'antd';

import Terms from '../../components/Terms/Terms'

import Datafetcher from '../../utils/datafetcher'

const { Title } = Typography;


interface Props {
    datafetcher: Datafetcher
}

interface State {
    username: string
    email: string
    password: string
    rememberMe: boolean
    login: boolean
    fullname: string
    sentRequest: boolean
    loginAttempt: boolean
    resetScreen: boolean
    phoneNumber: string
    rpassword: string
    terms: boolean
    resetPassword: string
    rresetPassword: string
    termsView: boolean
    forgotPassword: boolean
}

export default class componentName extends PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            username: "",
            email: "",
            password: "",
            rememberMe: true,
            login: true,
            fullname: "",
            sentRequest: false,
            loginAttempt: false,
            resetScreen: false,
            phoneNumber: "",
            rpassword: "",
            terms: false,
            resetPassword: "",
            rresetPassword: "",
            termsView: false,
            forgotPassword: false,
        };
    }

    componentDidMount() {
        if (window.location.pathname.split('/')[1] === "reset_password") {
            this.setState({ resetScreen: true })
        }
    }

    changeToSignup = () => {
        this.setState({ login: false })
    }

    changeToLogin = () => {
        this.setState({ login: true })
    }

    resetPassword = () => {
        if (!this.state.username) {
            toaster.notify(
                'Please enter your email.'
            )
            return
        }
        this.props.datafetcher.requestPasswordReset(this.state.username, (err, resp) => {
            if (err) {
                toaster.notify(
                    'Something went wrong.'
                )
                return
            }
            this.setState({ sentRequest: true })
        })
    }

    login = () => {
        if (!this.state.username) {
            toaster.notify(
                'Please enter your email.'
            )
            return
        }
        if (!this.state.password) {
            toaster.notify(
                'Please enter your password.'
            )
            return
        }
        this.setState({ loginAttempt: true })
        this.props.datafetcher.authenticateUser(this.state.username, this.state.password, (error, resp) => {
            if ((error && error.code === "409") || resp === null) {
                this.setState({ loginAttempt: false })
                toaster.notify(
                    'Wrong information provided. Check your email and password.'
                )
                return
            } else {
                const response = resp.data
                localStorage.setItem('token', response.token);
                localStorage.setItem('expires_at', response.expire);
                window.location.href = "/";
            }
        })
    }

    loginByParams = (username: string, password: string) => {
        if (!username) {
            toaster.notify(
                'Please enter your email.'
            )
            return
        }
        if (!password) {
            toaster.notify(
                'Please enter your password.'
            )
            return
        }
        this.setState({ loginAttempt: true })
        console.log(username)
        this.props.datafetcher.authenticateUser(username, password, (error, resp) => {
            if ((error && error.code === "409") || resp === null) {
                this.setState({ loginAttempt: false })
                toaster.notify(
                    'Wrong information provided. Check your email and password.'
                )
                return
            } else {
                const response = resp.data
                localStorage.setItem('token', response.token);
                localStorage.setItem('expires_at', response.expire);
                window.location.href = "/";
            }
        })
    }

    signup = () => {
        if (!this.state.username) {
            toaster.notify(
                'Please enter your email.'
            )
            return
        }
        if (!this.state.fullname) {
            toaster.notify(
                'Please enter your full name.'
            )
            return
        }
        if (!this.state.phoneNumber) {
            toaster.notify(
                'Please enter your phone number.'
            )
            return
        }
        if (!this.state.password) {
            toaster.notify(
                'Please enter your password.'
            )
            return
        }
        if (this.state.password.length < 8) {
            toaster.notify(
                'Your password should be atleast 8 characters long.'
            )
            return
        }
        if (!this.state.rpassword) {
            toaster.notify(
                'Please repeat your password.'
            )
            return
        }
        if (this.state.password !== this.state.rpassword) {
            toaster.notify(
                'Your passwords don\'t match.'
            )
            return
        }
        if (!this.state.terms) {
            toaster.notify(
                'Please agree to the terms and conditions.'
            )
            return
        }
        this.props.datafetcher.signUpUser(this.state.username, this.state.fullname, this.state.password, this.state.phoneNumber, (error) => {
            if (error && error.code === "409") {
                toaster.notify(
                    'Something went wrong. Please try again.'
                )
            } else {

                // if (typeof window !== "undefined") {
                //     if (window.fbq != null) {
                //         window.fbq('track', 'CompleteRegistration', {
                //             value: 5,
                //             currency: 'USD',
                //         });
                //     }
                // }
                this.login()
            }
        })
    }

    resetPasswordConfirm = () => {

        if (!this.state.resetPassword) {
            toaster.notify(
                'Please enter your password.'
            )
            return
        }
        if (this.state.resetPassword.length < 8) {
            toaster.notify(
                'Your password should be atleast 8 characters long.'
            )
            return
        }
        if (!this.state.rresetPassword) {
            toaster.notify(
                'Please repeat your password.'
            )
            return
        }
        if (this.state.resetPassword !== this.state.rresetPassword) {
            toaster.notify(
                'Your passwords don\'t match.'
            )
            return
        }

        const emailUri = this.getQueryVariable("email")
        const tokenUri = this.getQueryVariable("token")
        const timeUri = this.getQueryVariable("time")

        if (!emailUri || !tokenUri || !timeUri) { return }

        const email = decodeURIComponent(emailUri)
        const token = decodeURIComponent(tokenUri)
        const time = decodeURIComponent(timeUri)

        this.props.datafetcher.changePasswordThroughRequest(this.state.resetPassword, email, token, time, (error: any) => {
            if (error && error.code === "409") {
                toaster.notify(
                    'Something went wrong. Please try again.'
                )
            } else if (error) {
                toaster.notify('Something went wrong.')
                throw error
            } else {
                this.setState({
                    email: email,
                    username: email,
                    password: this.state.resetPassword
                })
                this.loginByParams(email, this.state.resetPassword)
            }
        })

    }

    getQueryVariable = (variable: string) => {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] === variable) { return pair[1]; }
        }
        return (false);
    }

    handleKeyPress = (event: any) => {
        if (event.key === 'Enter' && this.state.login) {
            this.login()
        }
    }

    render() {
        return (
            <>
            <Dialog
                    isShown={this.state.resetScreen}
                    width={400}
                    title="Change password"
                    hasFooter={false}
                    shouldCloseOnOverlayClick={false}
                    shouldCloseOnEscapePress={false}
                    hasClose={false}
                    hasCancel={false}
                    confirmLabel="Custom Label">
                    <Pane justifyContent={"space-between"} display="flex" flexDirection="row" overflow="scroll">
                        <Pane display="flex" flexDirection="column" overflow="scroll" marginTop={5} marginRight={30}>
                            <Text>Password: </Text>
                        </Pane>
                        <Pane display="flex" flexDirection="column" overflow="scroll">
                            <TextInput
                                width="100%"
                                type="password"
                                value={this.state.resetPassword}
                                onChange={(e: any) => this.setState({ resetPassword: e.target.value })}
                                name="password"
                                placeholder="Password"
                            />
                        </Pane>
                    </Pane>
                    <Pane justifyContent={"space-between"} marginTop={30} display="flex" flexDirection="row" overflow="scroll">
                        <Pane display="flex" flexDirection="column" overflow="scroll" marginTop={5} marginRight={30}>
                            <Text>Confirm password: </Text>
                        </Pane>
                        <Pane display="flex" flexDirection="column" overflow="scroll">
                            <TextInput
                                width="100%"
                                type="password"
                                value={this.state.rresetPassword}
                                onChange={(e: any) => this.setState({ rresetPassword: e.target.value })}
                                name="rpassword"
                                placeholder="Repeat password"
                            />
                        </Pane>
                    </Pane>
                    <Pane display="flex" flexDirection="column" overflow="scroll">
                        <Pane>
                            {this.state.sentRequest ?
                                <Alert
                                    intent="none"
                                    title="Password Changed!"
                                    marginTop={30}
                                    marginBottom={32}
                                />
                                :
                                <Button
                                    style={{ paddingLeft: 25, paddingRight: 25, marginRight: 16, marginTop: 25 }}
                                    type="primary"
                                    onClick={this.resetPasswordConfirm}>Change password</Button>
                            }
                        </Pane>
                    </Pane>
                </Dialog>

            <Dialog
                isShown={this.state.termsView}
                width={600}
                title="Terms and Conditions"
                hasFooter={false}
                hasCancel={false}
                shouldCloseOnOverlayClick={false}
                shouldCloseOnEscapePress={false}
                confirmLabel="Terms">
                <Terms></Terms>
            </Dialog>
            
            {this.state.loginAttempt ?
                <Pane display="flex" alignItems="center" flexDirection="column">
                    <Pane borderRadius={10} background="white" padding={25} marginTop="30vh" marginBottom="30vh" display="flex" alignItems="center" flexDirection="row">
                        <Spinner size={128} />
                    </Pane>
                </Pane> :
                <Pane
                    display="flex"
                    flexDirection="column"
                    justifyContent="center">
                    <Pane
                        clearfix
                        display="flex"
                        flexDirection="row"
                        justifyContent="center"
                        paddingTop={40}>
                            <img onClick={()=>window.location.replace("https://usesafewatch.com")} alt="Word Logo" width={356} height={150} src={require("../../images/word_logo.png")}></img>
                    </Pane>
                    <Pane
                        clearfix
                        display="flex"
                        flexDirection="row"
                        justifyContent="center"
                        borderRadius={15}
                        paddingTop={30}
                        marginBottom={150}>

                        <Pane
                            float="left"
                            backgroundColor="white"
                            borderRadius={4}
                            width={400}
                            margin={12}
                            paddingBottom={50}
                            display="flex"
                            flexDirection="column"
                            overflow="scroll">
                            <Pane
                                display="flex"
                                flexDirection="row"
                                justifyContent="center"
                                marginTop={50}>
                                    <Title>{this.state.login ? "Login" : "Signup"}</Title>
                            </Pane>
                            <Pane
                                display="flex"
                                flexDirection="row"
                                justifyContent="center"
                                marginTop={50}>
                                <TextInput
                                    value={this.state.username}
                                    onChange={(e: any) => this.setState({ username: e.target.value })}
                                    name="username"
                                    onKeyPress={this.handleKeyPress}
                                    placeholder={"Email"}
                                />
                            </Pane>

                            {!this.state.login ?
                                <Pane
                                    display="flex"
                                    flexDirection="row"
                                    justifyContent="center"
                                    marginTop={25}>
                                    <TextInput
                                        value={this.state.fullname}
                                        onChange={(e: any) => this.setState({ fullname: e.target.value })}
                                        name="fullname"
                                        placeholder="Full Name"
                                    />
                                </Pane> : <></>}

                            {!this.state.login ?
                                <Pane
                                    display="flex"
                                    flexDirection="row"
                                    justifyContent="center"
                                    marginTop={25}>
                                    <TextInput
                                        value={this.state.phoneNumber}
                                        onChange={(e: any) => this.setState({ phoneNumber: e.target.value })}
                                        name="phonenumber"
                                        placeholder="Phone number (For text notifications)"
                                    />
                                </Pane> : <></>}

                            <Pane
                                display="flex"
                                flexDirection="row"
                                justifyContent="center"
                                marginTop={25}>
                                <TextInput
                                    value={this.state.password}
                                    onChange={(e: any) => this.setState({ password: e.target.value })}
                                    onKeyPress={this.handleKeyPress}
                                    name="password"
                                    placeholder="Password"
                                    type="password"
                                />
                            </Pane>

                            {!this.state.login ?
                                <Pane
                                    display="flex"
                                    flexDirection="row"
                                    justifyContent="center"
                                    marginTop={25}>
                                    <TextInput
                                        value={this.state.rpassword}
                                        onChange={(e: any) => this.setState({ rpassword: e.target.value })}
                                        name="repeat password"
                                        placeholder="Repeat password"
                                        type="password"
                                    />
                                </Pane> : <></>}

                            {!this.state.login ?
                                <Pane
                                    display="flex"
                                    flexDirection="row"
                                    justifyContent="center"
                                    marginTop={25}>
                                    <Checkbox
                                        checked={this.state.terms}
                                        onChange={e => this.setState({ terms: e.target.checked })}
                                        label={<><Text>I agree to the</Text> <Link onClick={() => { this.setState({ termsView: true }) }}>terms and conditions.</Link></>}
                                    />
                                </Pane> : <></>
                            }

                            {this.state.login ?
                                <Pane
                                    display="flex"
                                    flexDirection="row"
                                    justifyContent="flex-end"
                                    marginTop={10}>
                                    <Link marginTop={15} marginLeft={75} marginRight={60} marginBottom={10} cursor={"pointer"} size={300} 
                                        onClick={() => { this.setState({ forgotPassword: true }) }}>Forgot Password?</Link>
                                </Pane> : <></>
                            }

                            <Pane
                                display="flex"
                                flexDirection="row"
                                justifyContent="flex-end"
                                marginTop={15}
                                marginRight={40}>
                                {this.state.login ? <>
                                    <Button
                                        style={{ paddingLeft: 25, paddingRight: 25, marginRight: 16 }} 
                                        type="primary" onClick={this.login}>Login</Button>
                                    <Button style={{ paddingLeft: 25, paddingRight: 25, marginRight: 16 }} 
                                     onClick={this.changeToSignup}>Sign up</Button>
                                </> :
                                    <>
                                        <Button 
                                            style={{ paddingLeft: 25, paddingRight: 25, marginRight: 16}}
                                            type="primary" 
                                            onClick={this.signup}>Sign up</Button>
                                        <Button 
                                            style={{ paddingLeft: 25, paddingRight: 25, marginRight: 16}}  
                                            onClick={this.changeToLogin}>Back</Button>
                                    </>
                                }
                            </Pane>
                        </Pane>
                    </Pane >
                </Pane>
    }</>
        )
    }
}
